export default "../css/813c2e4936aa04a094e706bfc27e37a3.ttf";